import axiosService from '../axios'

export const login = async (username: string, password: string) => {
  return axiosService({
    url: '/api.auth/login',
    method: 'post',
    data: {
      username,
      password,
    },
  })
}

export const checkToken = async () => {
  return axiosService({
    url: '/api.auth/check-token',
    method: 'post',
  })
}

export const logout = () => {
  return axiosService({
    url: '/api.auth/logout',
    method: 'post',
  })
}
